// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"3067": "08566aea","4777": "13f44d2c","5213": "a5e39a5d","5797": "e5b33855","6598": "25e50ce7","665": "d8530b68","8297": "d42829df","8772": "40e2b10f",}[chunkId] + ".css"
}